import request from '@/utils/request';
import type {
  SearchVehicleParams,
  VehicleCreatePayload,
  VehicleProductListResult,
  VehicleQueryResult,
  VehicleRecord
} from '@/types/vehicle';

export const getVehicle = (params: SearchVehicleParams) => {
  return request.get<VehicleRecord[] | VehicleQueryResult>(`/Vehicle/GetVehicle`, params);
};

export const createNewVehicle = (payload: VehicleCreatePayload) => {
  return request.post<null>(`/NewVehicles/CreateNewVehicles`, payload);
};

export const getVehicleProducts = () => {
  return request.get<VehicleProductListResult>(`/Catalogs/products`, {
    Page: 1,
    PageSize: 1000,
    IsDistributeOnly: true
  });
};